import React, { useEffect } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

type Props = {
  pageTitle: string;
  routeIsNotAllowed?: boolean;
} & RouteProps;

const RouterWithPageTitle = (props: Props) => {
  const { pageTitle, routeIsNotAllowed } = props;

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  if (routeIsNotAllowed) {
    return (
      <Redirect
        to={{
          pathname: '/member/profile',
          state: { scrollToDocs: false },
        }}
      />
    );
  }

  return <Route {...props} />;
};

export default RouterWithPageTitle;
